var angular = require('angular')
require('../../services/app.dataservice')
require('../../services/generator.dataservice')
require('../../services/disbursement.service')

angular.module('AemCspsDisbursementCalculator')
  .component('dps', {
    template: require('./dps.component.tpl.html'),
    controller: DpsCtrl,
    controllerAs: 'vm',
    bindings: {}
  })

DpsCtrl.$inject = ['appDataservice', 'generatorDataservice', 'disbursementService', 'userTracking', '$q', '$location']

function DpsCtrl (appDataservice, generatorDataservice, disbursementService, userTracking, $q, $location) {
  var vm = this
  var cancelers = []

  vm.$onInit = function () {
    vm.canRender = false
    vm.resultPension = null
    vm.resultDisbursement = null
    vm.submit = submit
    appDataservice.paramsPromise
      .then(function (res) {
        vm.disclaimerTextDPS = res.data.dpsParams.disclaimer
        vm.partyContributionSum = generatorDataservice.value('partyContributionSum', res.data.dpsParams, {
          min: 0,
          max: 10000000,
          default: 0,
          step: 1000
        })
        vm.employerContributionSum = generatorDataservice.value('employerContributionSum', res.data.dpsParams, {
          min: 0,
          max: 10000000,
          default: 0,
          step: 1000
        })
        vm.stateContributionSum = generatorDataservice.value('stateContributionSum', res.data.dpsParams, {
          min: 0,
          max: 10000000,
          default: 0,
          step: 1000
        })
        vm.yieldSum = generatorDataservice.value('yieldSum', res.data.dpsParams, {
          min: 0,
          max: 10000000,
          default: 0,
          step: 1000
        })
        vm.totalSavedAmount = {
          min: Math.max(vm.partyContributionSum.min, vm.employerContributionSum.min, vm.stateContributionSum.min, vm.yieldSum.min),
          max: Math.min(vm.partyContributionSum.max, vm.employerContributionSum.max, vm.stateContributionSum.max, vm.yieldSum.max),
          default: vm.partyContributionSum.default + vm.employerContributionSum.default + vm.stateContributionSum.value + vm.yieldSum.default,
          value: vm.partyContributionSum.value + vm.employerContributionSum.value + vm.stateContributionSum.value + vm.yieldSum.value,
          step: Math.min(vm.partyContributionSum.step, vm.employerContributionSum.step, vm.stateContributionSum.step, vm.yieldSum.step)
        }
        vm.isTotalSavedAmountPerPartes = vm.employerContributionSum.default > 0 || vm.stateContributionSum.default > 0 || vm.yieldSum.default > 0
        vm.pensionType = generatorDataservice.value('pensionType', res.data.dpsParams, { default: 'FIXED_TERM' })
        vm.desiredDisbursementPeriod = generatorDataservice.value('desiredDisbursementPeriod', res.data.dpsParams, {
          min: 24,
          max: 60,
          default: 24,
          step: 1
        })
        vm.desiredPensionAmount = generatorDataservice.value('desiredPensionAmount', res.data.dpsParams, {
          min: 100,
          max: 50000,
          default: 100,
          step: 1000
        })
        vm.isDesiredPensionAmountError = false
        vm.isDisbursementCombination = generatorDataservice.value('isDisbursementCombination', res.data.dpsParams, { default: false })
        vm.disbursementRatio = generatorDataservice.value('disbursementRatio', res.data.dpsParams, {
          min: 0,
          max: 100,
          default: 30,
          step: 1
        })
        vm.isRatioSubtextVisible = angular.isDefined(res.data.dpsParams.isRatioSubtextVisible) ? res.data.dpsParams.isRatioSubtextVisible : false
        vm.disbursementRatio.options = {
          translate: function (value) {
            return value + ' %'
          },
          hidePointerLabels: false,
          showSelectionBar: true,
          step: vm.disbursementRatio.step,
          floor: vm.disbursementRatio.min,
          ceil: vm.disbursementRatio.max,
          onEnd: submit
        }

        if (getParameterByName('totalSavedAmount')) {
          vm.totalSavedAmount.value = parseInt(getParameterByName('totalSavedAmount'))
          vm.isTotalSavedAmountPerPartes = true
        }
        if (getParameterByName('totalPartyContribution')) {
          vm.partyContributionSum.value = parseInt(getParameterByName('totalPartyContribution'))
        }
        if (getParameterByName('totalEmployerContribution')) {
          vm.employerContributionSum.value = parseInt(getParameterByName('totalEmployerContribution'))
        }
        if (getParameterByName('totalStateContribution')) {
          vm.stateContributionSum.value = parseInt(getParameterByName('totalStateContribution'))
        }
        if (getParameterByName('totalExpectedYield')) {
          vm.yieldSum.value = parseInt(getParameterByName('totalExpectedYield'))
        }
        return submit()
      })
      .finally(function () {
        vm.canRender = true
      })
  }

  function submit () {
    if (vm.isTotalSavedAmountPerPartes) {
      vm.totalSavedAmount.value = vm.partyContributionSum.value + vm.employerContributionSum.value + vm.stateContributionSum.value + vm.yieldSum.value
    } else {
      vm.partyContributionSum.value = vm.totalSavedAmount.value
      vm.employerContributionSum.value = 0
      vm.stateContributionSum.value = 0
      vm.yieldSum.value = 0
    }

    var dataPension = {
      totalSavedAmount: getPensionRatio(vm.totalSavedAmount.value),
      partyContributionSum: getPensionRatio(vm.partyContributionSum.value),
      employerContributionSum: getPensionRatio(vm.employerContributionSum.value),
      stateContributionSum: getPensionRatio(vm.stateContributionSum.value),
      yieldSum: getPensionRatio(vm.yieldSum.value)
    }

    cancelers.forEach(function (element) {
      element.resolve()
    })
    cancelers = []

    var promises = []
    if (vm.pensionType.value === 'FIXED_TERM') {
      dataPension.desiredDisbursementPeriod = vm.desiredDisbursementPeriod.value
      var requestTerm = disbursementService.dpsTerm(dataPension)
      userTracking.onRequest(dataPension)
      cancelers.push(requestTerm.canceler)
      promises.push(requestTerm.promise)
    } else {
      if (vm.isDisbursementCombination.value && vm.disbursementRatio.value === 0) {
        // fake dpsRent promise
        promises.push($q(function (resolve) {
          resolve({
            data: {
              pensionAmount: 0,
              pensionAmountAfterTax: 0,
              rentDisbursementPeriod: 0,
              taxOnPension: 0
            }
          })
        }))
      } else {
        dataPension.desiredPensionAmount = vm.desiredPensionAmount.value
        var requestRent = disbursementService.dpsRent(dataPension)
        userTracking.onRequest(dataPension)
        cancelers.push(requestRent.canceler)
        promises.push(requestRent.promise)
      }
    }

    if (vm.isDisbursementCombination.value) {
      var dataDisbursement = {
        totalSavedAmount: getDisbursementRatio(vm.totalSavedAmount.value),
        partyContributionSum: getDisbursementRatio(vm.partyContributionSum.value),
        employerContributionSum: getDisbursementRatio(vm.employerContributionSum.value),
        stateContributionSum: getDisbursementRatio(vm.stateContributionSum.value),
        yieldSum: getDisbursementRatio(vm.yieldSum.value)
      }
      var requestDisbursement = disbursementService.dpsDisbursement(dataDisbursement)
      userTracking.onRequest(dataDisbursement)
      cancelers.push(requestDisbursement.canceler)
      promises.push(requestDisbursement.promise)
    }

    vm.isDesiredPensionAmountError = false
    return $q.all(promises)
      .then(function (res) {
        userTracking.onResponse(res[0].data)
        vm.resultPension = res[0].data
        try {
          userTracking.onResponse(res[1].data)
          vm.resultDisbursement = res[1].data
        } catch (e) {}
      })
      .catch(function (err) {
        if (~err.status) {
          userTracking.onResponse(null, 'failed')
          if (err.status === 400) {
            vm.isDesiredPensionAmountError = true
            vm.resultPension = null
            vm.resultDisbursement = null
          } else {
            appDataservice.error = err
          }
        }
      })
  }

  function getPensionRatio (value) {
    if (vm.isDisbursementCombination.value) {
      return value * vm.disbursementRatio.value / 100
    } else {
      return value
    }
  }

  function getParameterByName (name) {
    var searchObject = $location.search()
    return searchObject[name]
  }

  function getDisbursementRatio (value) {
    if (vm.isDisbursementCombination.value) {
      return value * (100 - vm.disbursementRatio.value) / 100
    } else {
      return value
    }
  }
}
